<template>
  <RevCard
    class="flex cursor-pointer items-center justify-between px-16 py-24"
    hoverable
  >
    <div class="space-y-8">
      <div>
        <PolicyStateTag :state="policy.state" />
        <div class="body-1-bold">{{ policy.offerTitle }}</div>
      </div>
      <div class="text-static-default-low body-2">
        {{
          i18n(translations.subLabel, {
            productTitle: policy.productTitle,
          })
        }}
      </div>

      <div
        v-if="policy.state === 'NOT_STARTED' && policy.startDate"
        class="text-static-brand-hi body-2"
      >
        {{
          i18n(translations.startDate, {
            startDate: formatDate(policy.startDate),
          })
        }}
      </div>

      <div
        v-if="policy.state === 'CANCELLED'"
        class="text-static-info-hi body-2"
      >
        {{
          i18n(translations.cancelledOn, {
            endDate: formatDate(policy.endDate),
          })
        }}
      </div>

      <div v-if="policy.state === 'EXPIRED'" class="text-static-info-hi body-2">
        {{
          i18n(translations.expiredOn, {
            endDate: formatDate(policy.endDate),
          })
        }}
      </div>
    </div>
    <IconChevronRight />
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import PolicyStateTag from '~/scopes/dashboard/services-hub/components/PolicyStateTag/PolicyStateTag.vue'
import { INSURANCE_DATE_FORMAT } from '~/scopes/dashboard/services-hub/constant'
import type { Policy } from '~/scopes/dashboard/services-hub/types'

import translations from './PolicyCard.translations'

defineProps<{
  policy: Policy
}>()

const i18n = useI18n()

function formatDate(date: string) {
  return i18n.date(new Date(date), INSURANCE_DATE_FORMAT)
}
</script>
